var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.885 12.014L20.5 7.4v9.23l-4.615-4.615zM4.75 17.5l4.425-4.425 2.118 2.117a.999.999 0 001.414 0l2.117-2.117L19.25 17.5H4.75zM3.5 7.4l4.614 4.614L3.5 16.63V7.4zm4.22-.9H19.278l-4.454 4.453-1.06 1.061L12 13.778l-1.764-1.764-1.06-1.06L4.72 6.5H7.72zM21 5H3a1 1 0 00-1 1v12c0 .038.017.07.021.107a.991.991 0 00.98.893h18a.99.99 0 00.977-.893c.004-.037.022-.069.022-.107V6a1 1 0 00-1-1z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconEnvelope.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };